import React from 'react'

const Footer = () => {
  return (
    <footer>© 2022 By Waisuddin Nazari</footer>
  )
}

export default Footer